import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import "./COLlegadasPage.css";
import API_BASE_URL from "../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const VuelosPage = () => {
  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : null;
  const estacionUsuario = decoded?.estacion?.trim().toUpperCase();

  const [vuelos, setVuelos] = useState([]);
  const [pasajeros, setPasajeros] = useState([]);
  const [selectedVuelo, setSelectedVuelo] = useState(null);
  const [pasajeroSeleccionado, setPasajeroSeleccionado] = useState(null);
  const [modalAsignarVisible, setModalAsignarVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [colaboradores, setColaboradores] = useState([]);
  const [busquedaSiglas, setBusquedaSiglas] = useState("");
  const [busquedaVuelo, setBusquedaVuelo] = useState("");



  

  useEffect(() => {
    if (token) {
      obtenerVuelosDelDia();
    }
  }, [token]);

  const obtenerVuelosDelDia = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}api/vuelos/hoy`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const vuelosDelDia = res.data.filter(
        (v) => v.tipoServicio === "LLEGADAS"
      );
      setVuelos(vuelosDelDia);
    } catch (error) {
      console.error("❌ Error al obtener vuelos:", error);
      toast.error("Error al obtener vuelos del día");
    }
  };

  const obtenerColaboradores = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}api/bitacora/en-turno-detalles`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Primero filtramos por estación
    const colaboradoresFiltrados = res.data.filter(
      (colab) => colab.estacion?.trim().toUpperCase() === estacionUsuario
    );

    

    // Luego eliminamos duplicados por noColaborador
    const colaboradoresUnicos = colaboradoresFiltrados.filter(
      (colab, index, self) =>
        index === self.findIndex((c) => c.noColaborador === colab.noColaborador)
    );

    setColaboradores(colaboradoresUnicos);
  } catch (error) {
    console.error("❌ Error al obtener colaboradores:", error);
    toast.error("Error al cargar colaboradores disponibles");
  }
};




  const abrirModal = async (vuelo) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}api/vuelos/pasajeros/${vuelo.flight_number}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setPasajeros(res.data);
      setSelectedVuelo(vuelo);
      setModalVisible(true);
    } catch (error) {
      console.error("❌ Error al obtener pasajeros:", error);
      toast.error("Error al cargar pasajeros del vuelo");
    }
  };

  const asignarServicio = async (colab) => {
  try {
    const payload = {
      nombrePax: `${pasajeroSeleccionado.nombre} ${pasajeroSeleccionado.apellido}`,
      aerolinea: "AM", // puedes cambiarlo si es dinámico
      noVuelo: selectedVuelo.flight_number,
      noAsiento: pasajeroSeleccionado.tipo_pasajero,
      origenVuelo: selectedVuelo.latest_departure_airport,
      destinoVuelo: selectedVuelo.latest_arrival_airport,
      fechaInput: moment().format("YYYY-MM-DD"),
      horaInicio: moment().format("YYYY-MM-DD HH:mm:ss"),
      estacion: estacionUsuario,
      usuarioInicio: 999,
      noColaborador: colab.noColaborador,
      statusServicio: "EN CURSO",
      tipoVuelo: selectedVuelo.tipoServicio,
      pnr: pasajeroSeleccionado.pnr,
    };

    const res = await axios.post(`${API_BASE_URL}api/servicios/asignarLlegadas`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    toast.success("✅ Servicio asignado exitosamente");

    // Opcional: cerrar modales y limpiar
    setModalAsignarVisible(false);
    setModalVisible(false);
    setPasajeroSeleccionado(null);
    setSelectedVuelo(null);
    setPasajeros([]);

  } catch (error) {
    console.error("❌ Error al asignar servicio:", error);
    toast.error("Error al asignar el servicio");
  }
};


  const cerrarModal = () => {
    setModalVisible(false);
    setPasajeros([]);
    setSelectedVuelo(null);
  };
  const colaboradoresFiltradosPorBusqueda = colaboradores.filter((colab) =>
  colab.siglas?.toUpperCase().includes(busquedaSiglas)
);

const vuelosOrdenados = [...vuelos].sort((a, b) => {
  const horaA = moment.utc(a.published_arrival_time).tz("America/Mexico_City");
  const horaB = moment.utc(b.published_arrival_time).tz("America/Mexico_City");
  return horaA - horaB;
});


const vuelosFiltrados = vuelosOrdenados.filter((vuelo) =>
  vuelo.flight_number.toUpperCase().includes(busquedaVuelo)
);



  return (
    <div className="container mt-4">
      <ToastContainer />
      <h2 className="mb-4 titulo-llegadas">🛬 Vuelos de Llegadas del Día</h2>
      <div className="mb-3">
  <input
    type="text"
    className="form-control"
    placeholder="Buscar por número de vuelo"
    value={busquedaVuelo}
    onChange={(e) => setBusquedaVuelo(e.target.value.toUpperCase())}
  />
</div>

      <div className="cards-grid">
        {vuelosFiltrados.map((vuelo, idx) => (
          <div className="card-vuelo" key={vuelo.id} onClick={() => abrirModal(vuelo)}>
            
            <CardBody>
              <CardTitle tag="h5">
                {vuelo.flight_number} ({vuelo.latest_departure_airport} → {vuelo.latest_arrival_airport})
              </CardTitle>
              <CardSubtitle className="mb-2 text-muted">
                ⏱ {moment(vuelo.published_arrival_time).add(1, 'hour').format("HH:mm")} — Estatus: {vuelo.status}
              </CardSubtitle>
            </CardBody>
          </div>
        ))}
      </div>

      {modalVisible && (
        <div className="custom-modal-overlay" onClick={cerrarModal}>
          <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
            <div className="custom-modal-header">
              <span className="title">
                <i className="fa fa-user"></i> Pasajeros SABRE del vuelo {selectedVuelo?.flight_number}
              </span>
              <button className="close-button" onClick={cerrarModal}>✕</button>
            </div>

            <div className="custom-modal-body">
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
    <button className="btn-agregar">Agregar ＋</button>
  </div>
              <table className="table">
                <thead>
  <tr>
    <th>#</th>
    <th>Nombre</th>
    <th>Apellido</th>
    <th>Tipo silla</th>
    <th>Asiento</th>
    <th>Abordo</th>
    <th>Sala</th>
    <th>PNR</th>
    <th>Acciones</th> 
  </tr>
</thead>

                <tbody>
  {pasajeros.map((p, index) => (
    <tr key={index}>
      <td>{index + 1}</td>
      <td>{p.nombre}</td>
      <td>{p.apellido}</td>
      <td>{p.tipo_silla}</td>
      <td>{p.tipo_pasajero}</td>
      <td>{p.abordo ? "Sí" : "No"}</td>
      <td>{p.sala}</td>
      <td>{p.pnr}</td>
      <td>
        <button
  className="btn-asignar"
 onClick={async () => {
  setPasajeroSeleccionado(p);
  await obtenerColaboradores();
  setModalAsignarVisible(true);
}}

>
  Asignar
</button>

      </td>
    </tr>
  ))}
</tbody>

              </table>
            </div>
          </div>
          {modalAsignarVisible && (
  <div className="custom-modal-overlay" onClick={() => setModalAsignarVisible(false)}>
    <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
      <div className="custom-modal-header">
        <span className="title">
          Seleccionar colaborador para: <strong>{pasajeroSeleccionado?.nombre} {pasajeroSeleccionado?.apellido}</strong>
        </span>
        <button className="close-button" onClick={() => setModalAsignarVisible(false)}>✕</button>
      </div>
      <div className="custom-modal-body">
        {/* Aquí insertaremos luego el listado de colaboradores */}
        <input
  type="text"
  placeholder="Buscar por siglas..."
  className="form-control mb-3"
  value={busquedaSiglas}
  onChange={(e) => setBusquedaSiglas(e.target.value.toUpperCase())}
/>

<table className="table">
  <thead>
    <tr>
      <th>#</th>
      <th>Nombre</th>
      <th>Siglas</th>
      <th>Estación</th>
      <th>Acción</th>
    </tr>
  </thead>
  <tbody>
    
    {colaboradoresFiltradosPorBusqueda.map((colab, idx) => (

      <tr key={colab.noColaborador}>
        <td>{idx + 1}</td>
        <td>{colab.nombreCompleto}</td>
        <td>{colab.siglas}</td>
        <td>{colab.estacion}</td>
        <td>
          <button
  className="btn-asignar"
  onClick={() => asignarServicio(colab)}
>
  Seleccionar
</button>

        </td>
      </tr>
    ))}
  </tbody>
</table>
      </div>
    </div>
  </div>
)}

        </div>

        
      )}
    </div>
  );
};

export default VuelosPage;